import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';

const BASE_URL = `${OPAL_URL}/notification-service/api/v1/push`;

export async function getVapidPublicKey(): Promise<string> {
  const res = await http.get<{ public_key: string }>(`${BASE_URL}/vapid-public-key`);
  return res.data.public_key;
}

export async function subscribePush(subscription: PushSubscription): Promise<void> {
  const raw = subscription.toJSON();
  await http.post(`${BASE_URL}/subscribe`, {
    endpoint: subscription.endpoint,
    keys: {
      p256dh: raw.keys?.p256dh ?? '',
      auth: raw.keys?.auth ?? '',
    },
    user_agent: navigator.userAgent,
  });
}

export async function unsubscribePush(endpoint: string): Promise<void> {
  await http.post(`${BASE_URL}/unsubscribe`, { endpoint });
}
